import React from 'react';
import DatasetCatalogueAccordionFieldList from './DatasetCatalogueAccordionFieldList';
import DatasetCatalogueTabList from './DatasetCatalogueTabFieldList';
import DatasetCollectionsList from '../../collections/containers/DatasetCollectionsList';

const DatasetCatalogueLeft = ({
  asTab,
  category,
  code,
  direction,
  index = 0,
  panel = 'left',
  url,
}) => {
  const Component = asTab ? DatasetCatalogueTabList : DatasetCatalogueAccordionFieldList;
  return (
    <Component
      category={category}
      code={code}
      index={index}
      panel={panel}
      section="first"
      direction={direction}
      url={url}
    >
      <DatasetCollectionsList code={code} category={category} />
    </Component>
  );
};

export default DatasetCatalogueLeft;
